import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Location } from '@freelancer/location';
import { ABTest } from './abtest.service';

@Component({
  selector: 'fl-abtest',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ABTestComponent implements OnInit {
  constructor(private abtest: ABTest, private location: Location) {}

  ngOnInit() {
    const { searchParams } = new URL(this.location.href);
    const overridesParam = searchParams.get('overrides');

    if (overridesParam) {
      this.abtest.setOverridesMap(overridesParam);
    }

    if (searchParams.has('no_abtest')) {
      this.abtest.setGlobalOptOut(true);
    }
  }
}
